import { AppContext } from "@Context/common/general/context";
import { Card, CardProps, styled } from "@mui/material";
import { useContext } from "react";

const ProgressCard_ = styled((props: CardProps) => <Card variant="outlined" {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.dsBase.v100,
  borderRadius: theme.spacing(2),
}));
/**
 * TODO: The purpose of this functional component is to keep the color on the progress cards on mobile while the VR version
 * has an updated color (dsSurface.v100). When the mobile theme gets updated, this component should be removed, and only the styled
 * component above (ProgressCard_) should be used.
 */
export const ProgressCard = ({ children, backgroundColor }: { children: React.ReactNode, backgroundColor?: string}) => {
  const { state } = useContext(AppContext);
  const isVR = state.device.isVR;
  return <ProgressCard_ sx={backgroundColor ? { backgroundColor: backgroundColor } : isVR ? { backgroundColor: "dsSurface.v100" } : {}}>{children}</ProgressCard_>;
};
